import ethxSrc from '~/assets/ethx.svg'
import sfrxSrc from '~/assets/sfrx.svg'
import stEthSrc from '~/assets/stETH.svg'
import mEthSrc from '~/assets/mETH.svg'
import oethSrc from '~/assets/oeth.svg'
import rethSrc from '~/assets/rETH.svg'
import swethSrc from '~/assets/swETH.svg'

export const assets = [
  { symbol: 'stETH', src: stEthSrc, name: 'Lido Staked ETH' },
  { symbol: 'rETH', src: rethSrc, name: 'Rocket Pool ETH' },
  { symbol: 'sfrxETH', src: sfrxSrc, name: 'Staked Frax Ether' },
  { symbol: 'OETH', src: oethSrc, name: 'Origin Ether' },
  { symbol: 'mETH', src: mEthSrc, name: 'Mantle Staked Ether' },
  { symbol: 'ETHx', src: ethxSrc, name: 'Stader ETHx' },
  { symbol: 'swETH', src: swethSrc, name: 'Swell ETH' },
] as const

// Ensure there is a contract address for each asset above
export const contracts = {
  ETHx: '0xa35b1b31ce002fbf2058d22f30f95d405200a15b',
  stETH: '0x1643e812ae58766192cf7d2cf9567df2c37e9b7f',
  sfrxETH: '0xac3E018457B222d93114458476f3E3416Abbe38F',
  OETH: '0x856c4Efb76C1D1AE02e20CEB03A2A6a08b0b8dC3',
  mETH: '0xd5f7838f5c461feff7fe49ea5ebaf7728bb0adfa',
  rETH: '0xae78736cd615f374d3085123a210448e74fc6393',
  swETH: '0xf951e335afb289353dc249e82926178eac7ded78',

  trumpETH: '0x112dF87A0218D8eC581a47CfDa94BBBD87F6b4EF',
  lrtOracle: '0x9B298DbdbD6C39770A65f66e467932b39c3e4dd1',
  lrtDepositPool: '0x500F924e983E7975a3CC032F1943D108F0db8B03',
  lrtConfig: '0xcfFdB059747a9Cbc549275099DaFB5bE7d67f89A',
} as const

export const lrtOraclePriceMethod = 'trumpETHPrice'
